import type { Router } from 'vue-router';
import { ListFilter, PenLine } from '@lucide/vue';
import type { CommandFactory } from './commands';

// Mail's app-wide palette entries (I-2348): offered before Mail has been
// opened, so they only navigate — MailView consumes `?compose=1`
// (useRouteIntent) and the rules live in the settings hub. The entries
// on the selected message are Mail's own, registered while MailView is open
// (frontend/mail/src/mail/commandPalette/mailCommands.ts). Labels read
// „Mail: …“ like the navbar's entries, so the palette drops the navbar's
// „Neue E-Mail“ as a duplicate.

/** Mail's filter rules (Sieve) — the „filters" topic in the settings hub. */
const MAIL_RULES_PATH = '/settings/mail/filters';

/** The folder open right now while Mail is open, else Mail's start (the inbox). */
function mailPath(router: Router): string {
  const path = router.currentRoute.value.path;
  return path === '/mail' || path.startsWith('/mail/') ? path : '/mail';
}

export const mailCommands: CommandFactory = ({ router, t, appLabel: mail }) => [
  {
    id: 'mail.compose',
    label: `${mail}: ${t('mail.command.compose')}`,
    group: mail,
    app: 'mail',
    category: 'action',
    icon: PenLine,
    keywords: ['neue mail', 'new mail', 'e-mail', 'email', 'compose', 'verfassen', 'schreiben'],
    href: '/mail?compose=1',
    run: () => {
      void router.push({ path: mailPath(router), query: { compose: '1' } });
    },
  },
  {
    id: 'mail.rules',
    label: `${mail}: ${t('mail.command.editRules')}`,
    group: mail,
    app: 'mail',
    category: 'setting',
    icon: ListFilter,
    keywords: ['regeln', 'rules', 'filter', 'sieve', 'mailfilter', 'posteingangsregeln'],
    href: MAIL_RULES_PATH,
    run: () => {
      void router.push(MAIL_RULES_PATH);
    },
  },
];
